export default __webpack_public_path__ + "static/media/lobsters.29157c1b.mp3";